import { TextSmall } from '@/components/Texts';
import Link from 'next/link';
import React from 'react';

const ConditionsTransferPersonalData = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (8) Conditions for the transfer of personal data to third countries
      </TextSmall>
      <TextSmall>
        In the course of our business relationships, your personal data may be
        transferred or disclosed to third party companies. These may also be
        located outside the European Economic Area (EEA), i.e. in third
        countries. Such processing takes place exclusively for the fulfillment
        of contractual and business obligations and to maintain your business
        relationship with us (legal basis is Art. 6 para. 1 lit b or lit. f in
        each case in conjunction with Art. 44 et seq. GDPR). We will inform you
        about the respective details of the transfer in the following at the
        relevant points.
      </TextSmall>
      <TextSmall>
        Some third countries are certified by the European Commission as having
        a level of data protection comparable to the EEA standard through
        so-called adequacy decisions (a list of these countries and a copy of
        the adequacy decisions can be found here:{' '}
        <Link
          href={
            'https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en'
          }
          style={{ color: '#206bbb', cursor: 'pointer' }}
        >
          https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en
        </Link>
        ). However, in other third countries to which personal data may be
        transferred, there may not be a consistently high level of data
        protection due to a lack of legal provisions. If this is the case, we
        ensure that data protection is adequately guaranteed. This is possible
        via binding company regulations, standard contractual clauses of the
        European Commission for the protection of personal data pursuant to Art.
        46 para. 1 , 2 lit. c GDPR (the standard contractual clauses of 2021 are
        available at{' '}
        <Link
          href={
            'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32021D0915&locale-en'
          }
          style={{ color: '#206bbb', cursor: 'pointer' }}
        >
          https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32021D0915&locale-en
        </Link>
        ), certificates or recognized codes of conduct. Please contact our data
        protection officer (see under A.(3)) if you would like to receive more
        detailed information on this.
      </TextSmall>
      <TextSmall>
        <TextSmall as='span' textDecoration={'underline'}>
          EEA customers:
        </TextSmall>
        We will take all steps reasonably necessary to ensure that your Personal
        Information is treated securely and in accordance with this Privacy
        Statement. All data you provide to us is stored on our secure servers.
        Where we transfer our data outside of the EEA, we ensure that adequate
        safeguards are in place. That includes, where necessary, taking steps to
        evaluate the risks raised by the transfers in countries that do not
        offer an adequate level of protection. Please contact us if you want
        further information on the specific mechanism used by us when
        transferring your Personal Information out of the EEA.
      </TextSmall>
    </>
  );
};

export default ConditionsTransferPersonalData;
